import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  Typography,
  IconButton,
  useMediaQuery,
  Dialog,
  DialogContent,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  PlayCircleOutlined,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import Aashvi from "../img/compressed/img4.webp";
import aarin from "../img/compressed/Aarin.webp";
import surbhi from "../img/compressed/Surbhi.webp";
import Akshaj from "../img/compressed/Akshaj Garg.webp";
import Amay from "../img/compressed/Amay Nagpal.webp";
import Crimsy from "../img/compressed/Crimsy Goyal.webp";
import Manav from "../img/compressed/Manav Malik.webp";
import Rian from "../img/compressed/Rian Panjwani.webp";
import user_profile from "../img/user_profile.png";
import invert from "../img/icon/invert.png";
import "../../styles/components-styles/Testimonials.css";

const testimonialsData = [
  {
    image: Manav,
    name: "Manav Malik",
    location: "DLF Capital Greens",
    feedback: `Extremely grateful for the journey of my son which has been handheld by Hrishikesh sir and helped Manav understand and participate in enjoying the process of learning. Glad to have you in our life as a guru. Thank you for all your support. `,
    grade: "7th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
  {
    image: Aashvi,
    name: "Aashvi Dewar",
    location: "DLF Capital Greens",
    feedback: `I have seen a lot of improvement in my child. I really appreciate your style of teaching which keeps my kid engaged. The small activities that you do to motivate children is worth applauding. Keep doing your great work as you are a wonderful teacher and share great connection with children.`,
    grade: "7th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
  // {
  //   image: user_profile,
  //   name: "Adhira Sharma",
  //   location: "Online",
  //   feedback: `I am delighted to see the change in communication skills of my child and the vocabulary she uses. I am thankful to you for grooming my child in such wonderful way.`,
  //   grade: "6th Grade",
  //   rating: 5,
  //   duration: "Past 2 years",
  // },
  {
    image: Rian,
    name: "Rian Panjwani ",
    location: "DLF Capital Greens",
    feedback: `I have seen a lot of improvement in my child. I really appreciate your style of teaching which keeps my kid engaged. The small activities that you do to motivate children is worth applauding. Keep doing your great work as you are a wonderful teacher and share great connection with children.`,
    grade: "5th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
  {
    image: surbhi,
    name: "Surbhi Gupta",
    location: "DLF Capital Greens",
    feedback: `I have seen a lot of improvement in my child. I really appreciate your style of teaching which keeps my kid engaged. The small activities that you do to motivate children is worth applauding. Keep doing your great work as you are a wonderful teacher and share great connection with children.`,
    grade: "7th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
  {
    image: aarin,
    name: "Aarin Malik",
    location: "DLF Capital Greens",
    feedback: `Your influence goes beyond books. Your patience and dedication make you one of the best teachers we have ever had. May your passion for teaching continue to ignite the minds of many. Thank you for making learning an enjoyable experience.`,
    grade: "7th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
  {
    image: Crimsy,
    name: "Crimsy Goyal",
    location: "DLF Capital Greens",
    feedback: `Inspires confidence, engages students effectively, and fosters a positive learning environment. My daughter's progress is evident, and we're grateful for the positive impact. `,
    grade: "10th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
  {
    image: Amay,
    name: "Amay Nagpal",
    location: "Online",
    feedback: `IGreetings! Hrishikesh Sir, I am grateful for this online classes`,
    grade: "6th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
  {
    image: Akshaj,
    name: "Akshaj Garg",
    location: "DLF Capital Greens",
    feedback: `Hrishikesh sir has been a very good and knowledgeable teacher. He explains really well and my son is able to adapt easily thanks to him. We highly recommend him.`,
    grade: "7th Grade",
    rating: 5,
    duration: "Past 2 years",
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const isMobile = useMediaQuery("(max-width: 574px)"); // Detect mobile view

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonialsData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonialsData.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        handleNext();
      }, 5000);
      return () => clearInterval(interval); // Cleanup on unmount
    }
  }, [isMobile, currentIndex]); // Runs when isMobile or currentIndex changes

  // Preload all images on component mount
  useEffect(() => {
    const preloadImages = () => {
      const images = testimonialsData.map((testimonial) => testimonial.image);
      const imgElements = images.map((imageSrc) => {
        const img = new Image();
        img.src = imageSrc;
        return img;
      });

      // Once all images are loaded, set the loaded state
      let loadedCount = 0;
      imgElements.forEach((img) => {
        img.onload = () => {
          loadedCount += 1;
          if (loadedCount === imgElements.length) {
            setImagesLoaded(true); // All images have been loaded
          }
        };
      });
    };

    preloadImages();
  }, []);

  const { image, name, location, feedback, grade, rating, duration } =
    testimonialsData[currentIndex];

  return (
    <Box className="testimonials-container">
      <Typography variant="h4" className="testimonials-title">
        Testimonials
      </Typography>
      <Box className="testimonials-content">
        {!isMobile && (
          <IconButton onClick={handlePrev} className="testimonials-button">
            <ArrowBack />
          </IconButton>
        )}
        <Card className="testimonial-card">
          <Box className="testimonial-image-container">
            <img src={image} alt={name} className={`testimonial-image ${imagesLoaded ? "fade-in" : ""}`} />
            <Typography variant="subtitle1" className="testimonial-name">
              - {name}
              <br />
              {location}
            </Typography>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                borderRadius: "50%",
                padding: "10px",
              }}
            >
              {/* <IconButton onClick={handleOpen}>
                <PlayCircleOutlined
                  sx={{ color: "black", fontSize: "80px", opacity: 0.7 }}
                />
              </IconButton> */}
            </Box>
          </Box>
          {/* <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                color: "white",
                zIndex: 1000,
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box sx={{ position: "relative", padding: "20px" }}>
              <iframe
                width="100%"
                height="400"
                src="https://www.youtube.com/embed/eIho2S0ZahI?si=xueKdgpfmxJwDPZA"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </Box>
          </Dialog> */}
          <Box className="testimonial-text">
            <Typography variant="subtitle1" className="testimonial-mom">
              From {name}'s Mom
            </Typography>
            <Box className="testimonial-grade-container">
              <img
                src={invert}
                alt="double inverted commas"
                style={{ width: 24, height: 21, marginRight: 8 }}
              />
              <Typography variant="caption" className="testimonial-grade">
                {grade.charAt(0)}
                <span className="small-text">{grade.charAt(1)}</span>
                <span className="small-text">{grade.charAt(2)}</span>
                {grade.slice(3)}
              </Typography>
            </Box>
            <Typography variant="body1" className="testimonial-feedback">
              {feedback}
            </Typography>
            <Box className="testimonial-rating">
              {[...Array(rating)].map((_, i) => (
                <StarIcon key={i} className="star-icon" />
              ))}
            </Box>
            <Typography variant="caption" className="testimonial-duration">
              ({duration})
            </Typography>
          </Box>
        </Card>
        {!isMobile && (
          <IconButton onClick={handleNext} className="testimonials-button">
            <ArrowForward />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default Testimonials;
